import { createContext } from 'react';

const FoodContext = createContext();

export default FoodContext;
